import { render, staticRenderFns } from "./OrgModal.vue?vue&type=template&id=66f91ba7&"
import script from "./OrgModal.vue?vue&type=script&lang=js&"
export * from "./OrgModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports